/* Amalife PDP gallery — thumbnail click wiring.
   The two-card hero restyles Wonder's vertical thumb swiper into a horizontal row
   of squares BELOW the main image (see ama-pdp.css). That layout override breaks
   Swiper's built-in thumbs module, so we drive navigation ourselves: clicking a
   thumb calls the main swiper's slideTo(index); the main swiper's slideChange keeps
   the active-thumb highlight in sync (arrows/swipe included). The thumb row itself
   only renders at >=1080px (ama-pdp.css); this wiring is harmless elsewhere. */
(function () {
  function wire(gal) {
    if (!gal || gal.__amaThumbsWired) return;
    var mainEl = gal.querySelector('.photoswipe.swiper') || gal.querySelector('.wt-slider__container:not(.wt-slider__container--thumbs)');
    var thumbsWrap = gal.querySelector('.wt-slider__container--thumbs');
    if (!mainEl || !thumbsWrap) return;
    var sw = mainEl.swiper;
    if (!sw || typeof sw.slideTo !== 'function') return; // swiper not ready yet

    var thumbs = [].slice.call(thumbsWrap.querySelectorAll('.swiper-slide'));
    if (thumbs.length < 2) { gal.__amaThumbsWired = true; return; }

    gal.__amaThumbsWired = true;

    function setActive(idx) {
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].classList.toggle('swiper-slide-thumb-active', j === idx);
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        sw.slideTo(i);
        setActive(i);
      }, true);
    });

    // keep the highlight in sync when navigating via arrows / swipe
    if (typeof sw.on === 'function') {
      sw.on('slideChange', function () {
        setActive(typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex);
      });
    }
  }

  function boot() {
    document.querySelectorAll('.wt-product__gallery').forEach(wire);
  }

  if (document.readyState !== 'loading') boot();
  document.addEventListener('DOMContentLoaded', boot);
  // Swiper can initialise after DOMContentLoaded — retry briefly until wired.
  var tries = 0;
  var iv = setInterval(function () {
    boot();
    if (++tries > 25 || document.querySelector('.wt-product__gallery') && document.querySelector('.wt-product__gallery').__amaThumbsWired) {
      if (tries > 25) clearInterval(iv);
    }
  }, 250);
})();
